import React from 'react';
import { connect } from 'react-redux';
import PT from 'prop-types';
import { Control, Form, actions } from 'react-redux-form';
import { Button } from 'semantic-ui-react';
import ErrorMessage from '../UI_Elements/ErrorMessage';
import classes from './contentGate.css';
import keyIcon from '../../../assets/images/key.png';
import Link from '../../../lib/components/link';
import { loginAction } from '../../../store/actions/auth.actions';
import { SUBSCRIBE_NEW_VIEW, SUBSCRIBE_TMOBILE_VIEW } from '../../views/Subscribe/module/subscribe';
import { GO_LOGIN, GO_LOGOUT } from '../../../store/actions/auth.types';
import { REQUEST_PASSWORD_VIEW } from '../../views/PasswordRequest/module/requestPassword';
import { REQUEST_PASSWORD2_VIEW } from '../../views/PasswordForceRequest/module/requestPassword2';
import { RESET_PASSWORD_VIEW } from '../../views/PasswordReset/module/resetPassword';
import { REQUEST_USERNAME_VIEW } from '../../views/UsernameRequest/module/requestUsername';
import { RENEW_SUBSCRIPTION_VIEW } from '../../views/PaymentInformation/module';
import { ACCOUNT_INFORMATION_VIEW, CHANGE_PASSWORD_VIEW } from '../../views/AccountInfo/module/accountInfo';
import { VIEW as USER_EMAIL_SETTINGS_VIEW } from '../../../store/actions/emailSettings';
import { TEAM_VIEW, TEAM_VIEW_SUBVIEW } from '../../views/Team/module/team';
import { NEWS_VIEW, NEWS_VIEW_SUBVIEW } from '../../views/News/module/news';
import { DEPTHCHARTS_VIEW} from '../../views/DepthCharts/module/depthcharts';
import { PLAYER_VIEW, PLAYER_VIEW_SUBVIEW } from '../../views/Player/module/player';
import { HUDDLE_SEARCH_VIEW, PLAYER_LANDING_VIEW } from '../../views/HuddleSearch/module/huddleSearch';
import { SEASON_STATS_VIEW } from '../../views/Season/module/seasonStats';
import { NFL_SCHEDULE_GRID_VIEW, NFL_SCHEDULE_GRID_SUBVIEW } from '../../views/NFLSchedule/module/nflSchedule';
import { WEEKLY_STATS_VIEW } from '../../views/WeeklyStats/module/weeklyStats'
import { BOX_SCORES_VIEW } from '../../views/BoxScores/module/boxScores';
import { TEAM_POSITION_RANKINGS_VIEW } from '../../views/TeamPositionRankings/module/teamPositionRankings';
import { TEAM_PRM_VIEW } from '../../views/TeamPositionRanksMatchups/module/teamPRM';
import { GAME_STATS_MATCHUPS_VIEW } from '../../views/GameStatsMatchups/module/gameStatsMatchups';
import { SOS_VIEW } from '../../views/StrengthOfSchedule/module/strengthOfSchedule';

class ContentGate extends React.Component {
  static propTypes = {
    children: PT.node.isRequired,
    login: PT.func.isRequired,
    renew: PT.func.isRequired,
    loggedIn: PT.bool.isRequired,
    isExpired: PT.bool.isRequired,
    clickLogin: PT.func.isRequired,
    authForm: PT.object.isRequired,
    location: PT.string.isRequired,
    restricted: PT.array.isRequired,
    mediaType: PT.string.isRequired,
    error: PT.shape({
      status: PT.string,
      message: PT.string,
      meta: PT.shape({ fullUrl: PT.string }),
    }),
  };

  static defaultProps = {
    renew: ()=> null,
    login: () => null,
    clickLogin: () => null,
    authForm: {},
    error: null,
  };

  mobileRenewal = () => (
    <div>
      <div className={classes.signupSection}>
        <div className={classes.signupContent}>
          <div className={classes.mobileSubscribeHeader}>
            <div className={classes.subscribeHeader}>It’s time to renew</div>
            <img
              src={keyIcon}
              alt="Renewal Logo"
              className={`${classes.keyIcon} mobile`}
            />
          </div>
          <div className={classes.subscribeText}>
            Your paid subscription to The Huddle has expired. You must renew to
            continue accessing our tools and analysis for this season. Don’t let
            your competition have the advantage!
          </div>
          <div className={classes.callToAction}>THE GAME IS ON THE LINE</div>
          <div className={classes.buttonGroup}>
            <Button secondary fluid onClick={this.props.renew}>
              Renew Now
            </Button>
          </div>
        </div>
      </div>
    </div>
  );

  desktopRenewal = () => (
    <div className={classes.renewalSection}>
      <img src={keyIcon} alt="Renewal Logo" className={classes.keyIcon} />
      <div className={classes.signupContent}>
        <div className={classes.subscribeHeader}>It’s time to renew</div>
        <div className={classes.subscribeText}>
          Your paid subscription to The Huddle has expired. You must renew to
          continue accessing our tools and analysis for this season. Don’t let
          your competition have the advantage!
        </div>
        <div className={classes.callToAction}>THE GAME IS ON THE LINE</div>
        <div className={classes.buttonGroup}>
          <Button secondary onClick={this.props.renew}>
            Renew Now
          </Button>
        </div>
      </div>
    </div>
  );

  render() {
    const {
      authForm,
      loggedIn,
      isExpired,
      login,
      clickLogin,
      location,
      restricted,
      mediaType,
      error,
    } = this.props;
    // console.log(location);
    const exclusionList = [
      SUBSCRIBE_NEW_VIEW,
      SUBSCRIBE_TMOBILE_VIEW,
      GO_LOGIN,
      GO_LOGOUT,
      REQUEST_PASSWORD_VIEW,
      REQUEST_PASSWORD2_VIEW,
      RESET_PASSWORD_VIEW,
      REQUEST_USERNAME_VIEW,
      RENEW_SUBSCRIPTION_VIEW,
      ACCOUNT_INFORMATION_VIEW,
      CHANGE_PASSWORD_VIEW,
      USER_EMAIL_SETTINGS_VIEW,
      TEAM_VIEW,
      TEAM_VIEW_SUBVIEW,
      NEWS_VIEW,
      NEWS_VIEW_SUBVIEW,
      DEPTHCHARTS_VIEW,
      PLAYER_VIEW,
      PLAYER_VIEW_SUBVIEW,
      HUDDLE_SEARCH_VIEW,
      PLAYER_LANDING_VIEW,
      SEASON_STATS_VIEW,
      NFL_SCHEDULE_GRID_VIEW,
      NFL_SCHEDULE_GRID_SUBVIEW,
      WEEKLY_STATS_VIEW,
      BOX_SCORES_VIEW,
      TEAM_POSITION_RANKINGS_VIEW,
      TEAM_PRM_VIEW,
      GAME_STATS_MATCHUPS_VIEW,
      SOS_VIEW,
    ];

    const currentRouteRestricted = !(exclusionList.indexOf(location) > -1);

    const showContentGate = (
      <div className={classes.contentGate}>
        <div>{this.props.children}</div>
        <div className={classes.mask} id="contentGateMask" />
        <div className={classes.contentGateWrapper}>
          <div className={classes.loginSection}>
            <div className={classes.formWrapper}>
              {error && <ErrorMessage error={error} />}
              <div className={classes.signInCaption}>
                Sign In To Continue
              </div>
              <Form model="auth" onSubmit={login} name="loginForm" method="post">
                <Control.text
                  model="auth.credentials.uname"
                  id="auth.credentials.uname"
                  placeholder="Username"
                  className={classes.loginText}
                />
                <Control
                  type="password"
                  model="auth.credentials.password"
                  id="auth.credentials.password"
                  placeholder="Password"
                  className={classes.loginText}
                />
                <Button
                  type="submit"
                  disabled={!authForm.$form.valid}
                  onClick={clickLogin}
                  className={classes.loginButton}
                >
                  Sign In
                </Button>
                <div className={classes.forgotWrapper}>
                  <Link
                    className={classes.link}
                    to={{ type: REQUEST_PASSWORD_VIEW }}
                    label="Forgot your password?"
                  />&nbsp;&nbsp;
                  <Link
                    className={classes.link}
                    to={{ type: REQUEST_USERNAME_VIEW }}
                    label="Forgot your username?"
                  />
                </div>
              </Form>
            </div>
          </div>
        </div>
      </div>
    );

    const showRenewalContentGate = (
      <div className={classes.contentGate}>
        <div>{this.props.children}</div>
        <div className={classes.mask} />
        <div className={classes.contentGateWrapper}>
          {mediaType === 'mobile' ? (
            this.mobileRenewal()
          ) : (
            this.desktopRenewal()
          )}
        </div>
      </div>
    );

    return !loggedIn && currentRouteRestricted ? (
      showContentGate
    ) : isExpired && currentRouteRestricted ? (
      showRenewalContentGate
    ) : (
      <div>{this.props.children}</div>
    );
  }
}

const mapStateToProps = state => ({
  authForm: state.forms.auth,
  restricted: state.nav.restricted,
  location: state.location.type,
  mediaType: state.browser.mediaType,
  error: state.auth.error,
});

const mapDispatchToProps = dispatch => ({
  clickLogin: () => dispatch(actions.submit('auth')),
  login: () => dispatch(loginAction),
  renew: () => dispatch({ type: RENEW_SUBSCRIPTION_VIEW }),
});

const ConnectedContentGate = connect(mapStateToProps, mapDispatchToProps)(
  ContentGate,
);

export default ConnectedContentGate;



// WEBPACK FOOTER //
// ./src/app/components/ContentGate/ContentGate.js